import { css } from '@emotion/react';
import { Provider } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/provider.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { Page } from '@frontend/page';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { ProviderDetailsForm } from './provider-details-form';

type Props = {
  locationId: string;
  providerId: string;
  isMultiLocation: boolean;
};

export const EditProviderV3Page = ({ locationId, providerId, isMultiLocation }: Props) => {
  const { data, isLoading } = SchedulerV3.Queries.useGetProviderQuery({
    request: { id: providerId ?? '', childLocationId: isMultiLocation && locationId ? locationId : '' },
    options: {
      enabled: !!providerId,
    },
  });

  return (
    <Page maxWidth={1400} css={styles.page}>
      <ProviderDetailsForm
        providerDetails={data?.provider || ({} as Provider)}
        locationId={locationId}
        providerId={providerId}
        isLoading={isLoading}
      />
    </Page>
  );
};

const styles = {
  page: css`
    padding: ${theme.spacing(2)};

    @container (max-width: ${breakpoints.xsmall.max}px) {
      padding: ${theme.spacing(2)};
    }
  `,
};
